import * as React from "react"
import { Check, ChevronsUpDown } from "lucide-react"
import { cn } from "@lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "@components/shadcn-ui/popover";
import { Button } from "@components/shadcn-ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from "@components/shadcn-ui/command";

interface ComboboxProps {
    options: { value: string; label: string; email?: string; role?: string }[]
    value: string
    onValueChange: (value: string) => void
    placeholder?: string
}

export function Combobox({ options, value, onValueChange, placeholder }: ComboboxProps) {
    const [open, setOpen] = React.useState(false)

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="w-full justify-between"
                >
                    {value
                        ? options.find((option) => option.value === value)?.label
                        : placeholder || "Select..."}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-full p-0">
                <Command>
                    <CommandInput placeholder="Search..." />
                    <CommandEmpty>No user found.</CommandEmpty>
                    <CommandGroup>
                        {options.map((option) => (
                            <CommandItem
                                value={option.value}
                                onSelect={() => {
                                    onValueChange(option.value)
                                    setOpen(false)
                                }}
                            >
                                <Check
                                    className={cn(
                                        "mr-2 h-4 w-4",
                                        value === option.value ? "opacity-100" : "opacity-0"
                                    )}
                                />
                                <div>
                                    <div>{option.label}</div>
                                    {option.email && (
                                        <div className="text-xs text-muted-foreground">{option.email}</div>
                                    )}
                                </div>
                            </CommandItem>
                        ))}
                    </CommandGroup>
                </Command>
            </PopoverContent>
        </Popover>
    )
}
